<template>
  <div>
    <form-modal-shell>
      <div slot="content" class="form-modal-shell-content mb-3">
        <b-tabs class="nav-justified">
          <b-tab title="Login" title-link-class="form-tab-link" active>
            <sign-in-form></sign-in-form>
          </b-tab>

          <b-tab title="New account" title-link-class="form-tab-link">
            <sign-up-form></sign-up-form>
          </b-tab>
        </b-tabs>
      </div>
    </form-modal-shell>
  </div>
</template>

<script>
import FormModalDivider from "@/components/formModal/FormModalDivider.vue";
import FormModalShell from "@/components/formModal/FormModalShell.vue";
import SignInForm from "@/components/formModal/SignInForm.vue";
import SignUpForm from "@/components/formModal/SignUpForm.vue";
import SocialSignIn from "@/components/formModal/SocialSignIn.vue";

export default {
  components: {
    FormModalDivider,
    FormModalShell,
    SignInForm,
    SignUpForm,
    SocialSignIn
  }
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.form-modal-shell-content {
  .nav-tabs {
    margin-bottom: 30px;
  }

  .form-tab-link {
    padding: 15px;
    font-weight: 400;
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: $primary-accent !important;
    border: none !important;
    border-bottom: 3px solid $primary-accent !important;

    @include for-sm-phone-only {
      padding: 10px;
      font-size: 0.9rem;
    }
  }

  .form-tab-link:not(.active) {
    font-weight: 300;
    color: #999 !important;
    border-color: #999 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/formModal/AuthModal.vue